import { useState } from "react";
import { Box, CircularProgress } from "@mui/material";
import { UserRole, Vehicle } from "../../system/Domain";
import useAsyncEffect from "../../system/useAsyncEffect";
import axios from "axios";
import { useHistory } from "react-router";
import VehicleList from "./VehicleTable";
import Layout from "../../Components/Layout/Layout";
import VehiclesSidebar from "./VehiclesSidebar";
import Search from "../../Components/Search";
import useVehicleQuery from "../../system/useVehicleQuery";
import LotScanContextMenu from "./LotScanContextMenu";
import VehiclesNavigation from "Navigation/VehiclesNavigation";
import useUser from "../../system/useUser";

export type VehiclesSearchType = "plate" | "vin" | "fulltext";

const Vehicles = () => {
	const history = useHistory();
	const [vehicles, setVehicles] = useState<Vehicle[]>();
	const [, , hasRole] = useUser();
	const [searchType, setSearchType] = useState<VehiclesSearchType>("fulltext");

	const [query, setQuery, place, setPlace, resetQuery] = useVehicleQuery('vehicleQuery', {
		perspective: hasRole(UserRole.AldAdmin) ? "All" : "Stock",
		sort: "statusAssigned:desc",
		fullText: "",
		vin: "",
		plateNumber: ""
	});

	useAsyncEffect(async (cancelToken) => {
		const updatedQuery = ({
			...query,
			fullText: searchType === "fulltext" ? query.fullText : "",
			plateNumber: searchType === "plate" ? query.fullText : "",
			vin: searchType === "vin" ? query.fullText : "",
		})

		const { data } = await axios.post<Vehicle[]>(`/api/vehicles/search`, updatedQuery, {
			cancelToken: cancelToken.getAxiosToken()
		});

		setVehicles(data);
	}, [query, searchType]);

	const onUpdateVehicle = (vehicle: Vehicle) => {
		if (!vehicles) return;

		setVehicles(vehicles => vehicles?.map(s => s.id === vehicle.id ? vehicle : s));
	};

	return (
		<Layout
			title="Fahrzeuge"
			navigation={<VehiclesNavigation />}
			contextMenu={[<LotScanContextMenu />]}
			sidebar={(
				<VehiclesSidebar
					query={query}
					setQuery={setQuery}
					place={place}
					setPlace={setPlace}
					resetQuery={resetQuery}
					searchType={searchType}
					setSearchType={setSearchType}
				/>
			)}
		>
			<Box mb={2}>
				<Search
					value={query.fullText}
					realtime
					onSearch={(value) => value !== query.fullText && setQuery(q => ({
						...q,
						fullText: value
					}))}
				/>
			</Box>
			{!vehicles && (
				<Box m={2}>
					<CircularProgress size={48} />
				</Box>
			)}
			{vehicles && (
				<>
					{vehicles.length === 0 && (
						<Box>Keine Fahrzeuge vorhanden</Box>
					)}
					{vehicles.length > 0 && (
						<VehicleList
							vehicles={vehicles}
							onClick={v => history.push({
								pathname: `/vehicles/${v.id}`
							})}
							onUpdate={onUpdateVehicle}
							perspective={query.perspective}
						/>
					)}
				</>
			)}
		</Layout>
	);
};

export default Vehicles;
